/**
 * Where Settings → "Phones & email" is, as an address (Prest0n Everywhere S1c-1b-3; the owner, 2026-10-23: the F-16
 * notice's action "did not take them to the right place on the Settings page to confirm the number").
 *
 * The notice's action leads to /settings#phones-and-email (src/components/common/provePhoneBannerPolicy.ts), and the
 * section's hook lands there once its list door has answered (src/hooks/usePhonesAndEmail.ts). Imports nothing: the
 * banner band is on the first download, the section's hook on the settings pages' own.
 */

/** The hash that names the section. */
export const PHONES_AND_EMAIL_HASH = '#phones-and-email';

/** Whether an address's hash (`location.hash`) names the section, in any case. */
export function namesPhonesAndEmail(hash: string | null | undefined): boolean {
  return typeof hash === 'string' && hash.toLowerCase() === PHONES_AND_EMAIL_HASH;
}
